module.exports = __webpack_public_path__ + "img/medalha-industria-comercio.9351a05e.jpeg";